export const DEFAULT_PAGEVIEWS_QUOTA = 4.5;
//# sourceMappingURL=default-pageviews-quota.js.map